import axiosPrivate from "../../../api/axiosPrivate";
import {
  ATTACH_POLICY,
  CREATE_POLICY_CONFIG,
  DELETE_COVER,
  EDIT_SINGLE_APPLIED_POLICY_DETAILS,
  FILTER_APPLIED_POLICIES,
  GET_ALL_ACTIVE_POLICIES,
  GET_ALL_ACTIVE_SAVINGS_POLICIES,
  GET_ALL_POLICIES,
  GET_APPLIED_POLICIES,
  GET_FILTERED_POLICIES,
  GET_POLICY,
  GET_POLICY_CIRCLES,
  GET_SINGLE_APPLIED_POLICY_COVERS,
  GET_SINGLE_APPLIED_POLICY_DETAILS,
  GET_SINGLE_POLICY_DETAILS,
  GET_SINGLE_POLICY_HISTORY_DETAILS,
  GET_UPDATE,
  POLICY_COVER_BY_CATEGORY,
  RENEW_SINGLE_APPLIED_POLICY_DETAILS,
  SEARCH_APPLIED_POLICIES,
  SINGLE_POLICY_COVER,
  VIEW_CUSTOMER_POLICIES,
  VIEW_CUSTOMER_SING_POLICY_DETAIL,
} from "../../../api/constant";

const createPolicyConfig = async (data) => {
  const response = await axiosPrivate.post(CREATE_POLICY_CONFIG, data);
  return response.data;
};

const getAllPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_POLICIES}?page=${data?.pageNumber}&office_id=${data?.office_id}`
  );
  return response.data;
};

const getAllActivePolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_ACTIVE_POLICIES}/${data?.office_id}`
  );
  return response.data;
};

const getAllActiveSavingsPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_ACTIVE_SAVINGS_POLICIES}?office_id=${data?.office_id}`
  );
  return response.data;
};

const getFilteredPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_FILTERED_POLICIES}?page=${data?.pageNumber}&office_id=${data?.office_id}&search=${data?.search}`
  );
  return response.data;
};

const getPolicy = async (payload) => {
  const response = await axiosPrivate.get(
    `${GET_POLICY}${payload.id}?office_id=${payload.office_id}`
  );
  return response.data;
};

const updatePolicy = async ({ id, payload }) => {
  const response = await axiosPrivate.post(`${GET_UPDATE}${id}`, payload);
  return response.data;
};

const attachPolicyToCustomer = async (data) => {
  const response = await axiosPrivate.post(`${ATTACH_POLICY}`, data);
  return response.data;
};

const deleteCover = async ({ id }) => {
  const response = await axiosPrivate.get(`${DELETE_COVER}/${id}`);
  return response.data;
};

const getAppliedPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_APPLIED_POLICIES}?page=${data?.pageNumber}&office_id=${data?.office_id}`
  );
  return response.data;
};

const FilteredAppliedPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${FILTER_APPLIED_POLICIES}?page=${data?.pageNumber}&office_id=${data?.office_id}&staff_id=${data?.staff_id}`
  );
  return response.data;
};

const searchAppliedPolicies = async (data) => {
  const response = await axiosPrivate.post(`${SEARCH_APPLIED_POLICIES}`, data);
  return response.data;
};

const viewCustomerPolicies = async ({ customer_id }) => {
  const response = await axiosPrivate.get(
    `${VIEW_CUSTOMER_POLICIES}?customer_id=${customer_id}`
  );
  return response.data;
};
const getSinglePolicyDetails = async ({
  customer_id,
  policy_number,
  pageNumber,
}) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_POLICY_DETAILS}?customer_id=${customer_id}&policy_app_number=${policy_number}&page=${pageNumber}`
  );
  return response.data;
};

const getSinglePolicyHistory = async ({
  customer_id,
  policy_number,
  policy_cycle,
}) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_POLICY_HISTORY_DETAILS}?customer_id=${customer_id}&policy_application_number=${policy_number}&policy_cycle=${policy_cycle}`
  );
  return response.data;
};

const getSingleAppliedPolicyDetails = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_APPLIED_POLICY_DETAILS}?policy_app_no=${data?.policy_number}&customer_id=${data?.customer_id}`
  );
  return response.data;
};

const getSingleAppliedPolicyCovers = async (policy_number) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_APPLIED_POLICY_COVERS}/${policy_number}/""`
  );
  return response.data;
};

const editAttachPolicy = async (data) => {
  const response = await axiosPrivate.post(
    `${EDIT_SINGLE_APPLIED_POLICY_DETAILS}`,
    data
  );
  return response.data;
};

const renewPolicyToCustomer = async (data) => {
  const response = await axiosPrivate.post(
    `${RENEW_SINGLE_APPLIED_POLICY_DETAILS}`,
    data
  );
  return response.data;
};

const getSinglePolicyCover = async (data) => {
  const response = await axiosPrivate.get(`${SINGLE_POLICY_COVER}/${data.id}/${data.claim_category}`);
  return response.data;
};

const getPolicyCoverByCategory = async (id) => {
  const response = await axiosPrivate.get(`${POLICY_COVER_BY_CATEGORY}/${id}`);
  return response.data;
};

const getPolicyHistoryCircle = async (id) => {
  const response = await axiosPrivate.get(
    `${GET_POLICY_CIRCLES}?office_id=${id}`
  );
  return response.data;
};

const policyService = {
  createPolicyConfig,
  getAllPolicies,
  getAllActivePolicies,
  getFilteredPolicies,
  getAllActiveSavingsPolicies,
  getPolicy,
  getSinglePolicyCover,
  updatePolicy,
  attachPolicyToCustomer,
  deleteCover,
  getAppliedPolicies,
  FilteredAppliedPolicies,
  searchAppliedPolicies,
  viewCustomerPolicies,
  getSinglePolicyDetails,
  getSingleAppliedPolicyDetails,
  getSingleAppliedPolicyCovers,
  editAttachPolicy,
  getPolicyCoverByCategory,
  renewPolicyToCustomer,
  getPolicyHistoryCircle,
  getSinglePolicyHistory,
};

export default policyService;
